import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getmanage_participantsHandlerSaga(action) {
	const apiClient = apiClientFactory();
	console.log("MANAGE-PATICIPANTS", action.payload);
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "traningparticipants", ...action.payload }),
		);
		yield put({
			type: types.GET_MANAGE_PARTICIPANTS_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_MANAGE_PARTICIPANTS_ERROR,
			payload,
		});
	}
}

export function* getmanage_participantsWatcherSaga() {
	yield takeLatest(
		types.GET_MANAGE_PARTICIPANTS_START,
		getmanage_participantsHandlerSaga,
	);
}

//create

//delete

function* deletemanage_participantsHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("traningparticipants", action.payload),
		);
		yield put({
			type: types.DELETE_MANAGE_PARTICIPANTS_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_MANAGE_PARTICIPANTS_ERROR,
			payload,
		});
	}
}

export function* deletemanage_participantsWatcherSaga() {
	yield takeLatest(
		types.DELETE_MANAGE_PARTICIPANTS_START,
		deletemanage_participantsHandlerSaga,
	);
}

//update
